import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IQuestion } from "../exam_papers/types";

// 시험 간략 정보 인터페이스
export interface IExamBrief {
  id: string;
  title: string;
  exam_type: string;
}

// 상세 문제 정보 인터페이스 (시험 정보 포함)
export interface IQuestionWithExam extends IQuestion {
  exam: IExamBrief;
}

/**
 * 특정 문제의 상세 정보를 가져옵니다.
 * @param id 문제 ID
 * @returns API 응답
 */
export const apiGetQuestion = async (id: string) => {
  const response = await apiGet<IQuestionWithExam>(`/questions/${id}`);
  return response;
};

/**
 * 특정 문제의 상세 정보를 React Query를 통해 가져오는 훅
 * @param id 문제 ID
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetQuestion = (id: string, options = {}) => {
  return useQuery({
    queryKey: QueryKeys.question.detail(id),
    queryFn: async () => {
      const response = await apiGetQuestion(id);
      return response.data;
    },
    ...options,
    enabled: !!id,
  });
};

export default useQueryGetQuestion;
